export const basicFilters = {
  jewelry_type: null,
  primary_metal_type: null,
  ring_size: 6
}

export const primaryDiamondFilters = {
  shapes: [],
  colour: 'default_other',
  primary_diamond_size: 1.0
}

export const bailFilters = {
  has_bail: null,
  bail_type: null,
  bail_length_in_mm: 1.5,
  bail_straight_width_in_mm: 1.5,
  bail_tapered_width_in_mm: [1.0, 14.5]
}

export const bailDiamondFilters = {
  has_bail_diamond: null,
  bail_diamond_shape: null,
  bail_diamond_quality: null,
  bail_diamond_setting_style: null,
  bail_diamond_milgrain: null
}

export const centralHaloFilters = {
  has_central_halo: null,
  central_halo_custom_width: 1,
  central_halo_style: null,
  central_halo_width: null,
  central_halo_quality: null,
  central_halo_setting_style: null,
  central_halo_milgrain: null
}

export const pendantChainPanelFilters = {
  has_pendant_chain: null,
  pendant_chain_length: null,
  pendant_chain_width: null,
  pendant_chain_metal_type: null
}

export const multiStoneFilters = {
  multi_stone_ring: null,
  multi_stone_setting: null,
  multi_stone_quality: null,
  multi_stone_shape: [],
  small_diamond_id: {value: 0, label: ''}
}

export const sideStoneHaloFilters = {
  has_side_stone_halo: null,
  side_stone_halo_style: null,
  side_stone_overlapping_setting: null,
  side_stone_halo_width: null,
  side_stone_halo_custom_width: 1,
  side_stone_halo_quality: null,
  side_stone_halo_setting_style: null,
  side_stone_halo_milgrain: null
}

export const diamondsOnOutsideOfHaloFilters = {
  diamonds_on_outside_of_halo: null,
  quality_of_diamonds_on_outside_of_halo: null,
  setting_style_of_diamonds_on_outside_of_halo: null,
  milgrain_on_outside_of_halo: null
}

export const shankFilters = {
  vertical_shank_thickness: null,
  custom_vertical_shank_thickness: 1.3,
  shank_type: null,
  shank_shape: null,
  shank_straight_width: null,
  shank_straight_custom_width: 1.5,
  shank_tapered_width: [1, 15]
}

export const diamondsTopOfShankFilters = {
  has_diamonds_down_top_of_shank: null,
  diamonds_down_top_of_shank: null,
  distance_diamonds_down_top_of_shank: null,
  shape_of_diamonds_down_top_of_shank: null,
  quality_of_diamonds_down_top_of_shank: null,
  setting_style_of_diamonds_down_top_of_shank: null,
  milgrain_top_of_shank: null
}

export const diamondsSideOfShankFilters = {
  diamonds_on_outside_sides_of_shank: null,
  distance_diamonds_down_sides_of_shank: null,
  quality_of_diamonds_down_sides_of_shank: null,
  setting_style_of_diamonds_down_sides_of_shank: null,
  milgrain_sides_of_shank: null
}

export const prongFilters = {
  prong_style: null,
  prong_number: null,
  basket_style: null,
  cathedral_shoulders: null
}

export const additionalOptionsFilters = {
  additional_milgrain: null,
  hand_engraving: null,
  special_finish: null
}

export const additionalDiamondsFilters = {
  additional_diamond_quantity: 0,
  additional_diamond_shape: null,
  additional_diamond_quality: null,
  small_diamond_id: {value: 0, label: ''},
  additional_diamond_setting_style: null
}

export const stockItemFilters = {
  item_description: '',
  item_price: '',
  item_price_currency: null,
  primary_diamond_qty: 0
}

export const initialState = {
  filters: {
    ...basicFilters,
    basket_type: null,
    ...bailFilters,
    ...bailDiamondFilters,
    ...pendantChainPanelFilters,
    ...primaryDiamondFilters,
    ...centralHaloFilters,
    ...multiStoneFilters,
    ...sideStoneHaloFilters,
    ...diamondsOnOutsideOfHaloFilters,
    ...shankFilters,
    ...diamondsTopOfShankFilters,
    ...diamondsSideOfShankFilters,
    ...prongFilters,
    ...additionalOptionsFilters,
    ...stockItemFilters,
    additional_notes: '',
    additional_price: 0,
    additional_price_currency: null,
    additional_diamonds: {}
  },
  multiStoneSizeOption: [],
  verticalShankThicknessOptions: [],
  defaultShankWidthOptions: [],
  defaultHaloWidthOptions: [],
  isResetting: false,
  result: {},
  currentJewelryId: null,
  currentJewelryPriceIsFresh: false,
  modalRow: null,
  modalOpen: false,
  errorMsg: null
}



// WEBPACK FOOTER //
// ./src/reducers/jewelry-search/initial-state.js